import { withUserAccessCheck } from 'legacy/lut/hoc/withUserAccessCheck'
import { ComponentClass, FC, ReactNode } from 'react'

import { withInScopeCheck } from 'partner360/hoc/withInScopeCheck'

type Options = {
  accessOverlayPlaceholder?: ReactNode
  scopeOverlayPlaceholder?: ReactNode
}

export function withPartner360Checks<P extends object>(
  Component: FC<P> | ComponentClass<P>,
  { accessOverlayPlaceholder, scopeOverlayPlaceholder }: Options = {}
): FC<P> {
  return withUserAccessCheck(
    withInScopeCheck(
      (props) => {
        return <Component {...props} />
      },
      { overlayPlaceholder: scopeOverlayPlaceholder }
    ),
    {
      overlayPlaceholder: accessOverlayPlaceholder,
    }
  )
}
